import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxIconModule } from '../icon/icon.module';
import { PhxNavCardComponent } from './phx-nav-card.component';

@NgModule({
  declarations: [
    PhxNavCardComponent,
  ],
  imports: [
    PhxIconModule,
    CommonModule,
  ],
  exports: [
    PhxNavCardComponent,
  ]
})
export class PhxNavCardModule { }
